// extracted by mini-css-extract-plugin
export var button = "_5z-4";
export var hasDarkBackground = "_5z-7";
export var hasLightBackground = "_5z-6";
export var iconWrapper = "_5z-0";
export var large = "_5z-2";
export var medium = "_5z-1";
export var small = "_5z-5";
export var xsmall = "_5z-3";